module.exports = __webpack_public_path__ + "img/title-3.0071499b.png";